// src/hooks/useScrollToItem.js
import { useCallback } from "react";

const useScrollToItem = (headerSelector) => {
  return useCallback(
    (element) => {
      if (!element) return;

      // Find header element
      const header = document.querySelector(headerSelector);
      const headerHeight = header ? header.offsetHeight : 0;
      // Get clicked item absolute position
      const itemPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: itemPosition - headerHeight,
        behavior: "smooth",
      });
    },
    [headerSelector]
  );
};

export default useScrollToItem;
